import Service, { service } from '@ember/service';
import type FetchService from '@triptyk/ember-utils/services/fetch';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import type IntlService from 'ember-intl/services/intl';
import { ContactFormChangeset } from 'frontend/changesets/contact-form';
import type CurrentUserService from '../current-user';

/* jscpd:ignore-start */
export default class ContactFormChangesetService extends Service {
  @service declare fetch: FetchService;
  @service declare flashMessages: FlashMessageService;
  @service declare intl: IntlService;
  @service declare currentUser: CurrentUserService;

  async sendContactForm(changeset: ContactFormChangeset) {
    changeset.execute();
    const changesetData = changeset.data;

    const body = {
      type: changesetData.type,
      name: changesetData.name,
      email: changesetData.email,
      phone: changesetData.phone,
      message: changesetData.message,
    };

    try {
      await this.fetch.request('contact', {
        method: 'POST',
        body: JSON.stringify(body),
      });
      this.flashMessages.success(
        this.intl.t('components.modals.exit-modal.success_message')
      );
    } catch (e) {
      this.flashMessages.alert(
        this.intl.t('components.modals.exit-modal.fail_message')
      );
    }
  }

  emptyChangeset() {
    const user = this.currentUser.user;

    return new ContactFormChangeset({
      email: user?.email ?? '',
      phone: user?.phone ?? '+32',
      message: '',
      type: '',
      name: '',
    });
  }
}
/* jscpd:ignore-end */

declare module '@ember/service' {
  interface Registry {
    'changesets/contact-form': ContactFormChangesetService;
  }
}
